var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row row-container" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        {
          staticClass: "row",
          attrs: { "bg-row": `${_vm.getRowColor(_vm.value)}` }
        },
        [
          _c(
            "div",
            { staticClass: "col-2 col-sm col-12 border-right status pt-2" },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-5 col-md-12" },
                  [
                    _c("balloon", {
                      staticClass:
                        "w-md-90 w-100 mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center",
                      attrs: {
                        bg: `bg-${_vm.getColor(
                          _vm.value.assistanceApprovalStatusCd
                        )}`,
                        color: "font-weight-bold",
                        "pill-content-class": "justify-content-center",
                        text: _vm.value.assistanceApprovalStatusName,
                        "with-border": false
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-sm col-5 col-md-12 col text-center my-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Servicio: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "color-black font-16 font-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.value.serviceDescription) + " ")]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-sm col-2 col-md col d-md-none d-sm-block d-flex align-items-center"
                  },
                  [
                    _c("check-box", {
                      staticClass: "checkbox mt-3",
                      model: {
                        value: _vm.value.isChecked,
                        callback: function($$v) {
                          _vm.$set(_vm.value, "isChecked", $$v)
                        },
                        expression: "value.isChecked"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-3 col-sm col-12 pl-md-3 pl-md-4 pl-sm-4 mt-4 mt-md-4 mt-sm-4 pt-md-3"
            },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Estudiante: ")]
              ),
              _c(
                "span",
                { staticClass: "color-black font-16 font-weight-bold" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.value.studentSieId) +
                      " - " +
                      _vm._s(_vm._f("capitalize")(_vm.value.fullName)) +
                      " "
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "col-2 col-sm col-6 mt-3 mt-md-4 mt-sm-4 pt-md-3" },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Periodo: ")]
              ),
              _c(
                "span",
                { staticClass: "color-black font-16 font-weight-bold" },
                [_vm._v(" " + _vm._s(_vm.value.period) + " ")]
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "col-2 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3" },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Fecha de Nómina: ")]
              ),
              _c(
                "span",
                { staticClass: "color-black font-16 font-weight-bold" },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("date")(_vm.value.payrollDate)) + " "
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "col-1 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3" },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Asistencias: ")]
              ),
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "span",
                  { staticClass: "color-black font-16 font-weight-bold ml-1" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.value.assistanceDetailCount || "-") + " "
                    )
                  ]
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "col-1 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isRelatedPayment,
                      expression: "!isRelatedPayment"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Total: ")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "color-black font-16 font-weight-normal font-weight-bold"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("price")(_vm.value.costTotalAmt)) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-sm col-6 text-center mt-4 mt-md-4 mt-sm-4 pr-5 pt-4"
            },
            [
              _c("drop-down", {
                staticClass: "actions-dropdown",
                attrs: {
                  "data-item": { value: _vm.value, index: _vm.index },
                  items: _vm.actionItems
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pl-3 d-sm-none d-md-block border-left my-3 pt-3" },
            [
              _vm.getStatus(_vm.value.assistanceApprovalStatusCd) &&
              !_vm.isChildRelation(_vm.value)
                ? _c("check-box", {
                    staticClass:
                      "checkbox d-flex justify-content-center align-items-center mt-4",
                    attrs: { text: "" },
                    model: {
                      value: _vm.value.isChecked,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "isChecked", $$v)
                      },
                      expression: "value.isChecked"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "col-md-12 ml-n0 ml-md-n5 ml-sm-n0 mt-3 mt-md-0 mt-sm-3"
            },
            [
              _c("div", { staticClass: "row ml-n1" }, [
                _c("div", { staticClass: "col-md-2 ml-n1 border-right" }),
                _c(
                  "div",
                  { staticClass: "col-md-7" },
                  [
                    _c("payment-tags", {
                      model: {
                        value: _vm.value,
                        callback: function($$v) {
                          _vm.value = $$v
                        },
                        expression: "value"
                      }
                    })
                  ],
                  1
                ),
                _vm.showRemaingDays
                  ? _c(
                      "div",
                      {
                        staticClass: "col-md-2",
                        staticStyle: { "text-align": "right" }
                      },
                      [_vm._v(" Días en Vencimiento: ")]
                    )
                  : _vm._e(),
                _vm.showRemaingDays
                  ? _c(
                      "div",
                      {
                        staticClass: "col-md-1",
                        attrs: { color: `${_vm.getCountColor(_vm.value)}` }
                      },
                      [_vm._v(" " + _vm._s(_vm.value.daysInPayroll) + " ")]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ]),
    _c(
      "div",
      { staticClass: "col-1", staticStyle: { "max-width": "70px !important" } },
      [
        _c("compact-nav-tabs", {
          attrs: { value: _vm.generalTabIndex },
          on: {
            "on-select-tab-index": function($event) {
              return _vm.$emit("on-select-tab-index", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }